module.exports = __webpack_public_path__ + "static/media/211-djibouti.e7bc485c.svg";